import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    DeleteUserFromWorkShift,
    UserWorkSchedule,
} from '../../../../../reduxToolkit/CompanyWorkShift/CompanyWorkShiftApi';
import TableFunction from '../../../../../components/table/TableFunction';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import { useTranslation } from 'react-i18next';
import {buildFullNameLabel, errorMsg} from "../../../../../Apis/functions";
import {getWorkTimeAccess} from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsSlice";
import {SIMPLE_PAGINATION_MODEL} from "../../../../../components/table/Model/TableModel";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @param id
 */
const AssignedEmployeesApp = ({ id }) => {
    const WorkTimeAccess = useSelector(getWorkTimeAccess);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [selectedList, setSelectedList] = useState([]);
    const [deleteManageUser, setDeleteManageUser] = useState(false);
    const [addUserModal, setAddUserModal] = useState(false);
    const [searchResults, setSearchResults] = useState({content: [], totalElements: 0});
    const [modified, setModified] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [tableId] = useState('tbl_aef_employees');

    // Generates the table header with a single column labeled "name"
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} left={50} classes='first_head'>
                {t('name')}
            </CustomTh>,
        ];
    };

    // Generates the table body based on search results
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };
        let body = searchResults?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} left={50} classes={'first-column'}>
                        { buildFullNameLabel(item)}
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: searchResults?.content.map((e) => {
                return { ...e, id: e.userId };
            }),
        };
    };
    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const UsercontractPagination = SIMPLE_PAGINATION_MODEL.set({ page, rowsPerPage });

        dispatch(UserWorkSchedule({ id, UsercontractPagination })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success) {
                    setSearchResults(data);
                }
            },
        );
    }

    // Custom hook to manage the table: pagination, selection, headers, and body
    const {
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
        thead,
        tbody
    } =
        TableFunction({
            selectedList,
            setSelectedList,
            data: searchResults,
            labelRowsPerPage: 'users_per_page',
            getThead,
            getTbody,
            hasContainer: true,
            fixedPagination: false,
            setIsAllChecked,

            getData,//New
            modified,//New
            setModified,//New
        });

    // Delete selected users from the current work shift
    const deleteSelectedManageUser = (deleteItem) => {
        const data = {
            userIds: Array.isArray(deleteItem) ? deleteItem : [deleteItem],
            workShiftIds: [id],
        };

        dispatch(DeleteUserFromWorkShift(data)).then(({payload: { data: { success, code }}}) => {
            if(success) {
                setModified(true);
                setIsAllChecked(false);
                setSelectedList([]);
            }else errorMsg(code);
        });
    };

    return {
        selectedList,
        setSelectedList,
        deleteManageUser,
        setDeleteManageUser,
        addUserModal,
        setAddUserModal,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedManageUser,
        pagination,
        thead,
        tbody,
        tableId,
        setModified,
        modified,
        isAllChecked,
        setIsAllChecked,
        WorkTimeAccess,
        t
    };
};

export default AssignedEmployeesApp;
